import Select from "react-select";
import styled from "styled-components";

export const SelectStyled = styled(Select)`
  width: 100%;
  height: 40px;
  min-height: 40px;
  border-color: #cccc;
  position: relative;
  z-index: ${(props) => (props.isFocused ? 10 : 1)};
`;
